<section id="section-design-library" hlmCard>
  <div hlmCardHeader>
    <h2 hlmCardTitle>Gutschein-Designs</h2>
    <p hlmCardDescription>
      Jeder Gutschein wird als PDF gedruckt: Wert-Gutscheine mit einem Design, Produkt-Gutscheine
      mit einem anderen. Klicke auf ein Design, um es zu verwenden; „Aktiv“ zeigt, welches gerade
      gedruckt wird.
    </p>
  </div>

  <div hlmCardContent class="space-y-8">
    @if (loading()) {
      <div class="space-y-3" aria-busy="true">
        <hlm-skeleton class="h-4 w-32" />
        <div class="grid gap-3 sm:grid-cols-3">
          <hlm-skeleton class="h-28 w-full sm:h-72" />
          <hlm-skeleton class="h-28 w-full sm:h-72" />
          <hlm-skeleton class="h-28 w-full sm:h-72" />
        </div>
      </div>
    } @else {
      @for (group of groups(); track group.type) {
        <section class="space-y-3" [attr.aria-labelledby]="'design-group-' + group.type">
          <div class="space-y-1">
            <div class="flex flex-wrap items-center gap-2">
              <h3 [id]="'design-group-' + group.type" class="text-sm font-semibold">
                {{ group.label }}e
              </h3>
              @if (!group.enabled) {
                <span hlmBadge variant="outline">Ausgeschaltet</span>
              }
            </div>
            @if (!group.enabled) {
              <p hlmMuted class="text-xs">
                Produkt-Gutscheine sind unter
                <a class="underline" routerLink="/settings" [queryParams]="{ tab: 'sell-settings' }"
                  >Plugin-Einstellungen</a
                >
                ausgeschaltet. Sobald du sie einschaltest, werden sie mit dem aktiven Design
                gedruckt.
              </p>
            }
            @if (group.active?.status === 'draft') {
              <p class="text-destructive flex items-start gap-1.5 text-xs">
                <ng-icon name="lucideTriangleAlert" class="mt-0.5 shrink-0" />
                <span
                  >„{{ group.active?.name }}“ fehlt ein Pflichtelement (siehe „Pflichtangaben“
                  unten). Bis du es im Editor ergänzt, werden PDFs mit der Standardvorlage
                  gedruckt.</span
                >
              </p>
            }
          </div>

          <ul class="grid gap-3 sm:grid-cols-3">
            @if (!group.active) {
              <!-- No own design in use: the standard template prints -->
              <li
                class="border-primary ring-primary flex gap-3 rounded-lg border p-3 ring-1 sm:flex-col sm:gap-2">
                <div
                  class="bg-muted/40 text-muted-foreground relative flex w-20 shrink-0 items-center justify-center rounded border border-dashed sm:w-full"
                  style="aspect-ratio: 210 / 297"
                  aria-hidden="true">
                  <ng-icon name="lucideLayoutTemplate" size="24" />
                  <span
                    class="bg-primary text-primary-foreground absolute end-1.5 top-1.5 flex h-6 items-center gap-1 rounded-full ps-1.5 pe-2.5 text-xs font-medium shadow-sm">
                    <ng-icon name="lucideCheck" size="14" />
                    Aktiv
                  </span>
                </div>
                <div class="min-w-0">
                  <p class="text-sm font-medium">Standardvorlage</p>
                  <p hlmMuted class="text-xs">Wird gedruckt, bis du ein eigenes Design wählst.</p>
                </div>
              </li>
            }

            @for (design of group.designs; track design.public_id) {
              <li class="flex">
                <app-design-card
                  class="flex-1"
                  [design]="design"
                  [isActive]="design === group.active"
                  [busy]="busyId() !== null"
                  [working]="busyId() === design.public_id"
                  [previewBusy]="previewingId() !== null"
                  [previewing]="previewingId() === design.public_id"
                  (activate)="activate.emit($event)"
                  (copy)="copy.emit($event)"
                  (delete)="delete.emit($event)"
                  (preview)="preview.emit($event)" />
              </li>
            }

            <li class="flex">
              <button
                type="button"
                class="text-muted-foreground hover:bg-muted/50 flex-1 hover:text-foreground focus-visible:ring-ring/50 flex min-h-12 items-center justify-center gap-2 rounded-lg border border-dashed p-3 text-sm font-medium transition-colors focus-visible:ring-[3px] focus-visible:outline-none sm:min-h-72 sm:flex-col"
                (click)="create.emit(group.type)">
                <ng-icon name="lucidePlus" size="20" />
                Neues {{ group.label }}-Design
              </button>
            </li>
          </ul>
        </section>
      }
    }
  </div>
</section>
